import { render, staticRenderFns } from "./TabelaRecuperacaoSegmentacao.vue?vue&type=template&id=ff7f2cc4&"
import script from "./TabelaRecuperacaoSegmentacao.vue?vue&type=script&lang=js&"
export * from "./TabelaRecuperacaoSegmentacao.vue?vue&type=script&lang=js&"
import style0 from "./TabelaRecuperacaoSegmentacao.vue?vue&type=style&index=0&id=ff7f2cc4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports